import { ReactNode } from 'react';
import { Button, Message } from '@arco-design/web-react';
import { IconCopy } from '@arco-design/web-react/icon';
import { msg } from '../utils/msg';

export interface CopyTextProps {
  /** 待复制文本（空值渲染 -） */
  text?: string;
  /** 展示内容，默认同 text */
  children?: ReactNode;
}

async function doCopy(t: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(t);
      return true;
    }
  } catch {
    /* 非安全上下文走降级方案 */
  }
  try {
    const ta = document.createElement('textarea');
    ta.value = t;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}

export default function CopyText({ text, children }: CopyTextProps) {
  if (!text) return <span>-</span>;
  const onCopy = async () => {
    const ok = await doCopy(text);
    if (ok) {
      msg.copied();
    } else {
      Message.error('复制失败，请手动复制');
    }
  };
  return (
    <span className="bcc-copy-text">
      <span>{children ?? text}</span>
      <Button type="text" size="mini" icon={<IconCopy />} aria-label="复制" onClick={onCopy} />
    </span>
  );
}
